import styled from 'styled-components';
import {label} from 'styles/fragments';

export default styled.label`
	${label};
`;
